import { DatePipe, Location } from "@angular/common";
import { Injectable } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { UserIdleService } from "angular-user-idle";
import { BehaviorSubject, Observable } from "rxjs";
import { UserAccount } from "src/app/shared/models/user-account";
import { HttpService } from "./http.service";

@Injectable({
  providedIn: "root",
})
export class AppService {
  isSidebarPinned = false;
  isSidebarToggeled = false;

  constructor(
    private httpService: HttpService,
    private datePipe: DatePipe,
    private location: Location,
    private userIdle: UserIdleService
  ) {}

  private isProfileChange = new BehaviorSubject<any>(null);

  public NotificationCountChanged = new BehaviorSubject<boolean>(false);

  profileChange$ = this.isProfileChange.asObservable();

  private getCheckoutSession = new BehaviorSubject<any>(null);
  public userDetails = new BehaviorSubject<UserAccount>(null);

  currentDateFormat(
    y: number,
    m: number,
    d: number,
    h: number,
    min: number,
    sec: number,
    ms: number
  ) {
    const date = new Date();
    date.setFullYear(y);
    date.setMonth(m);
    date.setDate(d);
    date.setHours(h);
    date.setMinutes(min);
    date.setSeconds(sec);
    date.setMilliseconds(ms);
    return date;
  }

  getCheckoutSession$ = this.getCheckoutSession.asObservable();

  profileChange(user: UserAccount) {
    this.isProfileChange.next(user);
  }
  setSession(sessionId: string) {
    this.getCheckoutSession.next(sessionId);
  }

  toggleSidebar() {
    this.isSidebarToggeled = !this.isSidebarToggeled;
  }

  toggleSidebarPin() {
    this.isSidebarPinned = !this.isSidebarPinned;
  }

  getSidebarStat() {
    return {
      isSidebarPinned: this.isSidebarPinned,
      isSidebarToggeled: this.isSidebarToggeled,
    };
  }

  goBack() {
    this.location.back();
  }

  dateTransform(value: any) {
    this.datePipe.transform(value, "MM/dd/yyyy");
  }

  uploadProfile(file, base64File): Observable<any> {
    const fileObj = {
      FileName: file.name,
      File: base64File,
      DocumentType: file.type,
      status: "1",
    };
    const abc = { FilesMetadata: fileObj };
    return this.httpService.postAnonymous("account/SaveProfile", abc);
  }

  getUser(user): Observable<any> {
    return this.httpService.post("account/Get", user);
  }

  getRoleByPrefix(prefix): Observable<any> {
    return this.httpService.post("account/GetRoleByPrefix", prefix);
  }

  getRoleById(roleObj): Observable<any> {
    return this.httpService.post("account/GetRoleById", roleObj);
  }

  getGrades(): Observable<any> {
    return this.httpService.getAnonymous("master/ListGrade");
  }

  getCourses(): Observable<any> {
    return this.httpService.get("course/List");
  }

  getSubjects(): Observable<any> {
    return this.httpService.get("master/ListSubject");
  }

  getCountries(): Observable<any> {
    return this.httpService.getAnonymous("master/GetCountryList");
  }

  getStates(): Observable<any> {
    return this.httpService.getAnonymous("master/GetStateList");
  }

  getQualification(): Observable<any> {
    return this.httpService.getAnonymous("master/ListQualification");
  }

  getSpecialization(): Observable<any> {
    return this.httpService.getAnonymous("master/ListSpecialization");
  }

  getStatesByCountry(countryId): Observable<any> {
    // const Id = { CountryId: countryId };
    return this.httpService.getAnonymous("master/ListState");
  }

  getStatesByCountryId(countryId): Observable<any> {
    const Id = { countryId: countryId };
    return this.httpService.postAnonymous("master/GetStateByCountry", Id);
  }

  DoctorRegistration(user: any): Observable<any> {
    return this.httpService.postAnonymous("security/DoctorRegistration", user);
  }

  getSchoolsByCode(code: any): Observable<any> {
    return this.httpService.postAnonymous("school/ListByCode", code);
  }

  sendOTP(email: any): Observable<any> {
    return this.httpService.postAnonymous(
      "security/SendOTPForForgetPassword",
      email
    );
  }

  verifyOTP(userDetails): Observable<any> {
    return this.httpService.postAnonymous("security/VerifyOTP", userDetails);
  }

  sendRegistrationOTP(email: any): Observable<any> {
    return this.httpService.postAnonymous("security/RegistrationOTP", email);
  }

  sendOTPForVerify(email: any): Observable<any> {
    return this.httpService.postAnonymous("security/SendOTPForVerify", email);
  }

  getGradeById(grade): Observable<any> {
    return this.httpService.postAnonymous("security/getGradeById", grade);
  }
  getCourseById(course): Observable<any> {
    return this.httpService.postAnonymous("course/Get", course);
  }
  getSubjectById(subject): Observable<any> {
    return this.httpService.postAnonymous("subject/Get", subject);
  }

  getAuthCode(): Observable<any> {
    return this.httpService.get(`captcha/GetAuthcode`);
  }
  getCaptcha(code: string): Observable<any> {
    return this.httpService.get(`captcha/GetCaptcha?authCode=${code}`);
  }
  validateCaptha(code: string, text: string): Observable<any> {
    return this.httpService.get(
      `captcha/ValidateCaptcha?authCode=${code}&captcha=${text}`
    );
  }

  getProfilePicture(document) {
    return this.httpService.post("account/GetProfilePicture", document);
  }

  createSession(data) {
    const planData = { SessionData: data };
    return this.httpService.post(
      "subscription/CreateCheckoutSession",
      planData
    );
  }

  checkoutSession(sessionId) {
    const session = { SessionId: sessionId };
    return this.httpService.post("subscription/CheckoutSession", session);
  }

  ssoRegistration(user) {
    return this.httpService.postAnonymous("sso/SSORegistration", user);
  }

  UpdateUserDetails(userDetails: any): Observable<any> {
    return this.httpService.postAnonymous(
      "account/UpdateUserDetails",
      userDetails
    );
  }

  sendEmailOTP(email: any): Observable<any> {
    return this.httpService.postAnonymous("security/SendEmailOTP", email);
  }

  ChangeEmail(userDetails): Observable<any> {
    return this.httpService.post("security/ChangeEmail", userDetails);
  }

  SendPhoneOTP(userDetails): Observable<any> {
    return this.httpService.postAnonymous("security/SendPhoneOTP", userDetails);
  }

  ChangePhone(userDetails): Observable<any> {
    return this.httpService.post("security/ChangePhone", userDetails);
  }
  ForgetPassword(userAccount: any): Observable<any> {
    return this.httpService.post("account/ForgetPassword", userAccount);
  }
  ChangePassword(userAccount: any): Observable<any> {
    return this.httpService.post("account/ChangePassword", userAccount);
  }
  validateOldPassword(user: any): Observable<any> {
    return this.httpService.post("account/ValidateOldPassword", user);
  }
  DoctorUpdate(userDetails): Observable<any> {
    return this.httpService.postAnonymous("account/DoctorUpdate", userDetails);
  }
  DoctorAdd(userDetails): Observable<any> {
    return this.httpService.postAnonymous("security/DoctorRegistration", userDetails);
  }
  DoctorAllUpdate(userDetails): Observable<any> {
    return this.httpService.postAnonymous("account/Update", userDetails);
  }
  getDoctor(userDetails): Observable<any> {
    return this.httpService.postAnonymous("doctor/GetDoctorProfile", userDetails);
  }
  AccountUpdate(userDetails): Observable<any> {
    return this.httpService.postAnonymous("account/Update", userDetails);
  }
 
  GetPhysicianListForDropdown(userDetails): Observable<any> {
    return this.httpService.postAnonymous(
      "account/GetPhysicianListForDropdown",
      userDetails
    );
  }
  AddUserActivity(userActivity: any): Observable<any> {
    var activityDetails = {
      activityDetails: userActivity,
    };
    return this.httpService.postAnonymous(
      "activity/AddActivity",
      activityDetails
    );
  }
  GetUsersListForDropdown(userDetails): Observable<any> {
    return this.httpService.post(
      "account/GetUserListForDropdown",
      userDetails
    );
  }
  restart() {
    this.userIdle.resetTimer();
  }
  getCollectionlocations(userDetails): Observable<any> {
    return this.httpService.postAnonymous("pharmacyapi/GetPharmacyLocationList", userDetails);
  }
}
